import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSettings } from '../services/apiService';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    siteName: 'MedAgriCycle',
    siteDescription: 'Plateforme d\'innovation agricole méditerranéenne',
    email: 'contact@medagricycle.eu',
    phone: '+00 00 00 00 00',
    facebook: '',
    twitter: '',
    linkedin: '',
    instagram: '',
    youtube: ''
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getSettings();
        if (data) {
          setSettings(data);
        }
      } catch (error) {
        // Garder les valeurs par défaut en cas d'erreur
      } finally {
        setIsLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, isLoading }}>
      {children}
    </SettingsContext.Provider>
  );
};

